export interface AppCommonDiet {
  id: string;
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
  };
}

export class AppCommonDiet implements AppCommonDiet {
  id: string;
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
  };

  constructor() {
    this.id = "";
    this.organization_id = "";
    this.content = {
      name: "",
      type: "",
      description: "",
    };
  }
}